module.exports = __webpack_public_path__ + "static/media/smart mall edit.3994fec3.webp";